import * as React from "react";

import BaseProductCategoryListLayout from "./BaseProductCategoryListLayout";
import ProductCategoryCreatePopup from "../containers/products/ProductCategoryCreatePopup";

export default function () {
  return BaseProductCategoryListLayout(<ProductCategoryCreatePopup />);
}
